import { RouteConfig } from 'vue-router';

import { authenticatedGuard } from '@/common/auth';
import { facilityGuard, facilityAndAdminGuard } from './facility-guard';
import { adminGuard } from './admin-guard';

import MainComponent from '@/views/main/main.vue';
import InmatesComponent from '@/views/main/inmates.vue';
import FacilitiesComponent from '@/views/main/facilities.vue';
import SessionsComponent from '@/views/main/sessions.vue';
import ImportComponent from '@/views/main/import.vue';
import RulesComponent from '@/views/main/rules.vue';
import ConfirmationComponent from '@/views/main/confirmation.vue';
import FinishComponent from '@/views/main/finish.vue';
import ManageAccessComponent from '@/views/main/manageAccess.vue';
import StatusComponent from '@/views/main/status.vue';
import ImportAppRulesComponent from '@/views/main/importAppRules.vue';

export enum RouteNames {
    inmates = 'inmates',
    facilities = 'facilities',
    import = 'import',
    rules = 'rules',
    sessions = 'sessions',
    confirmation = 'confirmation',
    finish = 'finish',
    manage = 'manage',
    status = 'status',
    apps = 'apps'
}

export const Route: RouteConfig = {
    path: '/',
    component: MainComponent,
    beforeEnter: authenticatedGuard,
    children: [
        { path: '/', redirect: { name: RouteNames.facilities } },
        { path: '/facilities', name: RouteNames.facilities, component: FacilitiesComponent, props: true },
        { path: '/facilities/:facilityId/inmates', beforeEnter: facilityGuard, name: RouteNames.inmates, component: InmatesComponent, props: true },
        { path: '/facilities/:facilityId/sessions', beforeEnter: facilityGuard, name: RouteNames.sessions, component: SessionsComponent, props: true },
        { path: '/facilities/:facilityId/import', beforeEnter: facilityGuard, name: RouteNames.import, component: ImportComponent, props: true },
        { path: '/facilities/:facilityId/apps', beforeEnter: facilityAndAdminGuard, name: RouteNames.apps, component: ImportAppRulesComponent, props: true },
        { path: '/facilities/:facilityId/rules', beforeEnter: facilityAndAdminGuard, name: RouteNames.rules, component: RulesComponent, props: true },
        { path: '/facilities/:facilityId/confirmation', beforeEnter: facilityGuard, name: RouteNames.confirmation, component: ConfirmationComponent, props: true },
        { path: '/facilities/:facilityId/finish', beforeEnter: facilityGuard, name: RouteNames.finish, component: FinishComponent, props: true },
        { path: '/manage', beforeEnter: adminGuard, name: RouteNames.manage, component: ManageAccessComponent, props: true },
        { path: '/status', name: RouteNames.status, component: StatusComponent, props: true },

    ]
};
